import {useAppSelector} from "../../../../config/hooks";
import {getOrderForm} from "../../../../redux/selectors/orderFormSelector";
import {
  getSelectedCity
} from "../../../../redux/selectors/summaryReducer.selectors";
import {getPromoCode} from "../../../../redux/selectors/basketSelector";
import {parsePrice} from "../../../../utils";
import {
  getPrice,
  getSelectedSideOrdersPrice
} from "../../../../utils/orderFormPrices";
import NextStepButton from "./NextStepButton";
import useIsWide from "../../../../hooks/useIsWide";

const ThirdStepSummaryBar = () => {
  const orderForm = useAppSelector(getOrderForm);
  const selectedCity = useAppSelector(getSelectedCity);
  const promoCode = useAppSelector(getPromoCode);

  //Destructuring
  const {
    mealExchange: { days: customDays },
    sets,
  } = orderForm || {};
  const { code } = promoCode || {};
  const { sectorId } = selectedCity || {};

  const isMobile = useIsWide();

  return isMobile ? (
    <div className="steps-page-second__summary-bar">
      <div className="display-flex flex-direction-column justify-content-center">
        <p className="summary-bar__price-title">Suma zamówienia:</p>
        <p className="label-l color-gray-800">
          {parsePrice(
            getSelectedSideOrdersPrice(customDays, sets) +
            getPrice(orderForm, code, sectorId)
          )}{' '}
          zł
        </p>
      </div>
      <NextStepButton />
    </div>
  ) : null
};

export default ThirdStepSummaryBar;
